export default {
  name: 'easyboss',
  env: "prod",
  baseURL: `https://www.easyboss.com`,
  appId: 'wxbc7c3c0d99d32e78',
  wxMpRegisterUrlBase: `https://m.easyboss.com`,
};
